import ContentFragment from './ContentFragment';
export default `
	query FindContent($filter: JSON, $type: String) {
		findContent(filter: $filter, type: $type) {
			... ContentFragment
		}
	}
	${ContentFragment}
`;
